// extracted by mini-css-extract-plugin
export default {"contenedor":"estilos_contenedor__6xDbw"};